import { SearchBaseModel } from '../commonModels';


export class PricelistDetailSearchModel extends SearchBaseModel {
  public IsActive: boolean;
  public GarageId: number;
  public CustomerId: number;
  public PricelistId: number;
  public Article: string;

  constructor() {
    super();
    this.IsActive = null;
    this.GarageId = null;
    this.CustomerId = null;
    this.PricelistId = null;
    this.Article = null;
    }
}
